import { JarvisSuggestionType, OXGAvailabilityIndicatorColor } from '../enum';
import { AdditionalPageOptions, ImageHeaderData, JarvisProduct, JarvisSuggestion, ResultCardConfigType } from '../interface';
import { objectToStringArray } from './object';
import { AvailabilityIndicator, WholebuyAvailabilityIndicatorColor } from '../enum';
import { isFiberOXG, isFiberWholebuy, isProductInConstructionPhase } from './jarvisHelpers';

/**
 * Jarvis suggestion types that have a "Fit für die Zukunft" flag badge
 */
const FIBER_STATES_WITH_FLAG = [
    JarvisSuggestionType.PRE_SALES,
    JarvisSuggestionType.HOMES_PASSED,
    JarvisSuggestionType.FIBER,
];

/**
 * Get CMS config from additionalPageOptions
 * @returns {object} - CMS config
 */
export const getCMSConfig = (): Partial<AdditionalPageOptions> =>
    window.additionalPageOptions || {};

export const getFixnetProducts = () =>
    objectToStringArray(window.additionalPageOptions?.fixedProducts);

export const getImageHeaderData = (type?: JarvisSuggestionType, isFriendsAndFamily?: boolean): ImageHeaderData | undefined => {
    const { imageHeader } = getCMSConfig();

    if (isFriendsAndFamily) {
        return imageHeader?.friendsAndFamily;
    }

    switch (type) {
        case JarvisSuggestionType.CABLE:
            return imageHeader?.cable;
        case JarvisSuggestionType.FIBER:
            return imageHeader?.fiber;
        default:
            return imageHeader?.regular;
    }
};

/**
 * Get primary result card config from CMS config based on type
 * @param type - JarvisSuggestionType || WholebuyAvailabilityIndicatorColor | OXGAvailabilityIndicatorColor
 * @returns
 */
export const getResultCardConfig = (type: ResultCardConfigType) =>
    getCMSConfig().postAvc?.[type];

export const getPrimaryFlagText = (secondary?: JarvisSuggestionType) => {
    if (!secondary) {
        return '';
    }

    if (secondary && FIBER_STATES_WITH_FLAG.includes(secondary)) {
        return '';
    }

    return getCMSConfig().flagBadge?.primary;
};

export const getSecondaryFlagText = (secondary?: JarvisSuggestionType) =>
    secondary && FIBER_STATES_WITH_FLAG.includes(secondary)
        ? getCMSConfig().flagBadge?.fiber
        : '';

/**
 * Get secondary result card config from CMS config based on type
 * @param secondary - JarvisSuggestion
 * @returns
 */
export const getSecondaryResultCardConfig = (secondary: JarvisSuggestion) => {
    const availabilityIndicator = secondary?.product?.availabilityIndicator as AvailabilityIndicator;
    // Determine the appropriate config based on conditions
    const isOXGFiber = isFiberOXG(secondary);
    const isWholebuyFiber = isFiberWholebuy(secondary);
    const isInConstructionPhase = isProductInConstructionPhase(secondary.product as JarvisProduct);

    let config;

    if (isOXGFiber && isInConstructionPhase) {
        config = getResultCardConfig(OXGAvailabilityIndicatorColor[availabilityIndicator]);
    } else if (isWholebuyFiber && isInConstructionPhase) {
        config = getResultCardConfig(WholebuyAvailabilityIndicatorColor[availabilityIndicator]);
    } else {
        config = getResultCardConfig(secondary.type);
    }

    return config;
};
